import { dot } from '../utils/do-dot'
import config from './config'
import { getSrc } from './util'
import { isPC } from '../utils/micro-utils'

export default function watch() {
  if (isPC()) {
    document.addEventListener('mousedown', documentClkHandler)
  } else {
    document.addEventListener('click', documentClkHandler)
  }
}

function documentClkHandler(e) {
  const { target } = e

  let __target = target

  // 直到找到一个带有config.pidAttr的元素为止
  while (
    __target &&
    __target.tagName &&
    __target.tagName.toLowerCase() !== 'body' &&
    __target.tagName.toLowerCase() !== 'html'
  ) {
    if (__target.hasAttribute(config.pidAttr)) {
      const pid = __target.getAttribute(config.pidAttr)
      const imgUrl = getSrc(__target)
      doDot(pid, imgUrl)
      break
    }
    __target = __target.parentNode
  }
}

function doDot(pid, imgUrl) {
  if (!imgUrl) return

  dot(config.logkey, 'CLK', {
    [pid]: imgUrl,
  })
}
